import React from 'react';
import {DropdownV2} from '@priority-software/priority-style-react';
import {FieldSearchDropdownProps} from '../../../components/Common/FieldSearch/types/DropdownProps';
import {iSearchDropdownCloseKey} from '../utils/keys';
import {InputTrigger} from './InputTrigger';

export const InputDropdown = (props: FieldSearchDropdownProps & {contentComponent: any}) => {
    const {
        dropdownStyle,
        onClose,
        onKeyDown,
        className,
        contentStyle,
        contentComponent: DropdownContent,
        triggerRef,
        column
    } = props;

    return (
        <DropdownV2
            componentClasses={className}
            isOpen={props.isOpen}
            style={dropdownStyle}
            contentStyle={contentStyle}
            onClose={onClose}
            onKeyDown={onKeyDown}
            trigger={<InputTrigger {...props} />}
            triggerRef={triggerRef}
            isCloseKeyCallback={iSearchDropdownCloseKey}
            oldStyles
        >
            <DropdownContent {...props} hasStatus={column?.isStatus} />
        </DropdownV2>
    );
};
